import { observer } from 'mobx-react';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getIconForFileProvider as getAddProviderIconCSS } from 'owa-fileprovider-icon';
import { getAddableFileProviders } from 'owa-fileprovider-store/lib/selectors/getAddableFileProviders';
import loc from 'owa-localize';
import * as React from 'react';
import { showFileProviderInlineView } from '../actions/internalActions';
import { getFilePickerStore } from '../store/filePickerStore';
import { AddAFileProvider } from './AddFileProviderView.locstring.json';
import FileProviderView from './FileProviderView';
import showFilePickerOption from './utils/showFilePickerOption';

const styles = require('./AddFileProviderView.scss');

@observer
export default class AddFileProviderView extends React.Component<{}> {
    render() {
        return (
            <div>
                {this.shouldShowAddAProviderView() && (
                    <FileProviderView
                        name={loc(AddAFileProvider)}
                        icon={getAddProviderIconCSS(ControlIcons.Add, styles.icon)}
                        onClick={this.onAddProviderClicked}
                        ariaLabel={loc(AddAFileProvider)}
                        isSelected={getFilePickerStore().viewState.showFileProviderInlineView}
                    />
                )}
            </div>
        );
    }

    // We only show the "Add a Provider" button when there is some provider that is addable that the user does not yet have.
    // Otherwise it would clutter the left nav, and clicking it would open an empty panel.
    private shouldShowAddAProviderView(): boolean {
        return getAddableFileProviders().length > 0;
    }

    private onAddProviderClicked() {
        if (isFeatureEnabled('doc-filePicker-storageAccountView')) {
            showFileProviderInlineView(true);
        } else {
            showFilePickerOption();
        }
    }
}
